import { cn } from '@/lib/utils';

type Status =
  | 'pending'
  | 'done'
  | 'skipped'
  | 'confirmed'
  | 'checked_in'
  | 'checked_out'
  | 'cancelled'
  | string;

interface Props {
  status: Status;
  className?: string;
}

const LABEL: Record<string, string> = {
  pending: 'Pending',
  pending_payment: 'Awaiting payment',
  requested: 'Requested',
  confirmed: 'Confirmed',
  confirmed_deposit: 'Deposit paid',
  paid: 'Paid',
  checked_in: 'Checked in',
  checked_out: 'Checked out',
  completed: 'Completed',
  cancelled: 'Cancelled',
  no_show: 'No-show',
  // Waitlist statuses
  waiting: 'Waiting',
  contacted: 'Contacted',
  booked: 'Booked',
  expired: 'Expired',
  // Task board statuses
  done: 'Done',
  skipped: 'Skipped',
};

const COLOR: Record<string, string> = {
  pending: 'bg-warning/15 text-warning-foreground',
  pending_payment: 'bg-warning/15 text-warning-foreground',
  requested: 'bg-warning/15 text-warning-foreground',
  confirmed: 'bg-primary/10 text-primary',
  confirmed_deposit: 'bg-primary/15 text-primary',
  paid: 'bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-200',
  checked_in: 'bg-success/15 text-success',
  checked_out: 'bg-secondary text-muted-foreground',
  completed: 'bg-secondary text-muted-foreground',
  cancelled: 'bg-destructive/10 text-destructive',
  no_show: 'bg-destructive/10 text-destructive',
  done: 'bg-success/15 text-success',
  skipped: 'bg-secondary text-muted-foreground',
  // Waitlist statuses
  waiting: 'bg-warning/15 text-warning-foreground',
  contacted: 'bg-primary/10 text-primary',
  booked: 'bg-success/15 text-success',
  expired: 'bg-secondary text-muted-foreground',
};

export function StatusPill({ status, className }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium leading-none',
        COLOR[status] ?? 'bg-secondary text-muted-foreground',
        className,
      )}
    >
      {LABEL[status] ?? status}
    </span>
  );
}
